<script setup lang="ts">
import type { Lesson, LessonSlots } from '../../../model/lessons/interfaces'

import { ModalDefault } from '@shared/ui/modals'
import { NativeSelect } from '@shared/ui/fields'
import { BtnPrimary, BtnSecondary } from '@shared/ui/buttons'

import { useModalLessonCancel } from '../../../model/lessons/modal-lesson-cancel.hook'

defineOptions({
  name: 'ModalLessonCancel',
})

const props = withDefaults(defineProps<{
  lesson: Lesson
  slots?: LessonSlots | null
  /** What the page does once the write succeeded, before the modal closes. */
  afterSave: () => Promise<void>
}>(), {
  slots: null,
})

const emit = defineEmits<{
  close: []
}>()

const {
  refStatusOptions,
  refStatus,
  refCategoryOptions,
  refCategory,
  refReasonOptions,
  refReason,
  refIsSaving,
  setStatus,
  setCategory,
  setReason,
  close,
  confirm,
} = useModalLessonCancel({
  lesson: props.lesson,
  slots: props.slots,
  close: () => emit('close'),
  afterSave: props.afterSave,
})
</script>

<template>
  <ModalDefault
    show
    class-name="modal-lesson-dialog"
    title="Cancel lesson"
    :loading="refIsSaving"
    @click:overlay="close"
  >
    <div class="modal-lesson-cancel">
      <NativeSelect
        name="lesson_status"
        label="Status"
        :options="refStatusOptions"
        :value="refStatus"
        :disabled="refIsSaving"
        required
        @change="setStatus"
      />
      <NativeSelect
        name="reason_category"
        label="Reason category"
        :options="refCategoryOptions"
        :value="refCategory"
        :disabled="refIsSaving"
        required
        @change="setCategory"
      />
      <NativeSelect
        name="cancel_reason"
        label="Cancellation reason"
        :options="refReasonOptions"
        :value="refReason"
        :disabled="refIsSaving"
        required
        @change="setReason"
      />
    </div>
    <template #controls>
      <div class="modal-lesson-form__controls">
        <BtnPrimary
          text="Cancel lesson"
          color="emerald"
          :disabled="refIsSaving"
          @click="confirm"
        />
        <BtnSecondary
          text="Cancel"
          color="black"
          :disabled="refIsSaving"
          @click="close"
        />
      </div>
    </template>
  </ModalDefault>
</template>

<style scoped lang="scss" src="./ModalLessonForm.scss" />
